import React, { useEffect, useState } from "react";
import { BulkRescheduleAppointments } from "@secondcloset/web-components";

import { useUploadBulkRescheduleCsv } from "./hooks/useUploadBulkRescheduleCsv";

import * as S from "./styles";

import { useDownloadCsvTemplate } from "./hooks/useDownloadCsvTemplate";
import { validateCsv } from "./helpers/validateCsv";

export const BulkRescheduleAppointmentPage: React.FC = () => {
  const [appointmentsCsvFile, setAppointmentsCsvFile] = useState<File>();
  const [csvError, setCsvError] = useState<string[]>([]);

  const { uploadCsv, isUploading, isSuccess: isUploadSuccess } = useUploadBulkRescheduleCsv();
  const { downloadCsvTemplate, isDownloadingTemplate } = useDownloadCsvTemplate();

  useEffect(() => {
    isUploadSuccess && setAppointmentsCsvFile(undefined);
  }, [isUploadSuccess]);

  const onSubmitClick = () => {
    if (!appointmentsCsvFile) return;
    uploadCsv({ bulkRescheduleCsv: appointmentsCsvFile });
  };

  const onSetCsv = async (csv?: File) => {
    if (!csv) {
      // remove uploaded csv
      setAppointmentsCsvFile(undefined);
      return;
    }
    try {
      await validateCsv(csv);
      setAppointmentsCsvFile(csv);
      setCsvError([]);
    } catch (errors) {
      setCsvError((errors as string[]).slice(0, 50));
    }
  };

  return (
    <S.Container>
      <BulkRescheduleAppointments
        appointmentsCsvFile={appointmentsCsvFile}
        errors={csvError}
        isDownloadingTemplate={isDownloadingTemplate}
        isUploadingCsv={isUploading}
        setAppointmentsCsvFile={onSetCsv}
        onDownloadTemplate={downloadCsvTemplate}
        onSubmitClick={onSubmitClick}
      />
    </S.Container>
  );
};
